export class Portifolio {
    PDF: string;
    Videos?: string[];
}